import React from "react";
import { Box } from "@material-ui/core";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import QuestionResources from "../question-resources/question-resources";
import ExplanationMarkdownBoundary from "../explanation-markdown-boundary/explanation-markdown-boundary";
import { toExplanationMarkdown } from "../../utils/explanation-markdown";
import "./detailed-guidance-content.scss";

// QIR B3 (§4/§5): the shared, PRESENTATIONAL explanation renderer — one renderer,
// two mounts. Extracted VERBATIM from the exam-review-drawer explanation core so the
// student "Detailed Guidance" surface is byte/DOM-unchanged (I1) while the
// review-queue QuestionDetail panel gains the identical student format (banner,
// prose, key-points box, additional-explanation section) in the same visual order.
//
// CONTENT FIELDS ONLY (I4): the component receives explanation content + display
// flags. No quiz/attempt/user props cross in; each mount maps its own source
// (drawer: quiz-derived guideData; review: B2's ReviewQuestionContextDto). It fetches
// nothing (I2) and holds no state — a pure function of its props.
//
// I1 byte-parity contract with the drawer's pre-extraction markup:
//   - correct-answer banner renders iff `correctAnswerText` is truthy;
//   - the FULL `explanation` box renders iff `showFullExplanation` (mirrors the
//     drawer's `isAdmin && <Box>` gate EXACTLY — gated on the flag alone, never on
//     content presence, so the admin student render is unchanged);
//   - the brief/additional boxes render iff their own field is truthy.
// The classNames + element nesting are identical to the extracted source; the
// drawer's own SCSS continues to style the student mount unchanged.
// Clinical text stays intact (thresholds like "- >5 cm", "<ULN"), and content the
// parser cannot handle falls back to plain text instead of blanking the app.
const ExplanationMarkdown = ({ text }) => (
  <ExplanationMarkdownBoundary text={text}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{toExplanationMarkdown(text)}</ReactMarkdown>
  </ExplanationMarkdownBoundary>
);

const DetailedGuidanceContent = ({
  correctAnswerText,
  explanation,
  briefExplanation,
  additionalExplanation,
  showFullExplanation = false,
  refLinks,
}) => (
  <>
    {correctAnswerText && (
      <Box className="ans-item">The correct answer is <span className="correct-ans-lbl">{correctAnswerText}</span></Box>
    )}

    {showFullExplanation && (
      <Box className="exp-text MuiTypography-body1 content-body"><ExplanationMarkdown text={explanation} /></Box>
    )}

    {briefExplanation && (
      <Box className="exp-text brief-exp MuiTypography-body1 additional-exp content-body"><ExplanationMarkdown text={briefExplanation} /></Box>
    )}

    {additionalExplanation && (
      <Box className="exp-text MuiTypography-body1 additional-exp content-body"><ExplanationMarkdown text={additionalExplanation} /></Box>
    )}
    <QuestionResources refLinks={refLinks} />
  </>
);

export default DetailedGuidanceContent;
